import { UndefinedInitialDataOptions, useQuery } from "@tanstack/react-query";
import { adminChargeServices } from "./admin-charge.services";
import { PaginationResponse, type QueryParams as TQueryParams } from "../type";
import { ADMIN_CHARGE_KEYS } from "./admin-charge.keys";
import { QueryAdminChargeParams } from "./admin-charge.types";
import { TAdminCharge } from "~/types/admin-charge";

export const useGetAdminCharges = (opts?: {
  params?: QueryAdminChargeParams & TQueryParams;
  query?: Omit<
    UndefinedInitialDataOptions<PaginationResponse<TAdminCharge>>,
    "queryKey" | "queryFn"
  >;
}) => {
  return useQuery({
    queryKey: ADMIN_CHARGE_KEYS.GET_ADMIN_CHARGES(opts?.params),
    queryFn: () => adminChargeServices.getAdminCharges(opts?.params),
    ...opts?.query,
  });
};

export const useGetAdminCharge = (id?: string) => {
  return useQuery({
    queryKey: ADMIN_CHARGE_KEYS.GET_ADMIN_CHARGE(id!),
    queryFn: () => adminChargeServices.getAdminCharge(id!),
    enabled: !!id,
  });
};
